var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48467,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.48467,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    stroke: "#EAEBF0",
    strokeWidth: 0.96934
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_1435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2141 26.8353C29.1184 25.6188 27.559 24.8032 25.8913 24.2692C25.1866 24.0436 24.4622 24.5122 24.3667 25.2459C24.1657 26.7904 24.1657 28.2662 24.3668 29.8107C24.4623 30.5444 25.1867 31.013 25.8914 30.7874C27.5591 30.2534 29.1185 29.4378 30.2141 28.2213C30.5704 27.8257 30.5703 27.2309 30.2141 26.8353Z",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1933 33.248C21.6427 35.1401 24.0011 36.1501 27.1413 36.1501C32.6593 36.1501 35.7632 33.0317 35.7632 27.4878C35.7632 22.6563 33.4057 19.6669 29.1473 18.9785",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2159 21.6992C19.6171 22.4724 19.1714 23.3943 18.8876 24.4563",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7853 19.6766C23.628 19.2874 24.5884 19.0285 25.6599 18.9065",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5197 27.4878C18.5197 28.5066 18.6245 29.4434 18.8299 30.294",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_1435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(17.1415 17.5283)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveVideos);
export default __webpack_public_path__ + "static/media/active_videos.2219ce11a532f810e78ce12c9acb0a63.svg";
export { ForwardRef as ReactComponent };